<template>
  <div class="nav-container">
    <div class="logo">
      <img src="../../../assets/images/logo.png" alt="" />
    </div>
    <div class="nav-wrap">
      <div class="nav-item" :class="item.route == $route.path ? 'active' : ''" @click="toggleNav(index, item.route)"
        v-for="(item, index) in nav" :key="item.id">{{ item.menuName }}</div>
    </div>
    <div class="right">
      <div class="wrap">
        <!-- <div class="search">
          <div class="search-icon">
            <svg t="1761720930449" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="4751" width="20" height="20">
              <path
                d="M474.666667 106.666667a368 368 0 1 0 368 368 368 368 0 0 0-368-368z m0 661.333333a293.333333 293.333333 0 1 1 293.333333-293.333333 293.653333 293.653333 0 0 1-293.333333 293.333333z"
                p-id="4752"></path>
              <path
                d="M736.741464 789.544104m3.771236-3.771236l45.254834-45.254834q3.771236-3.771236 7.542473 0l122.452038 122.452038q3.771236 3.771236 0 7.542472l-45.254834 45.254834q-3.771236 3.771236-7.542472 0l-122.452039-122.452038q-3.771236-3.771236 0-7.542472Z"
                p-id="4753"></path>
            </svg>
          </div>
        </div> -->
        <!-- <div class="inter">
          <svg t="1761721819725" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7415" width="20" height="20">
            <path
              d="M192 704v49.408a85.504 85.504 0 0 0 79.36 85.44h92.16a42.944 42.944 0 0 1 0 85.952H278.016a172.16 172.16 0 0 1-172.032-171.968v-65.728A43.008 43.008 0 0 1 192 686.976V704z m593.92-185.728l150.464 376a43.008 43.008 0 0 1-79.872 32l-40.96-101.952H639.936l-40.512 101.888a43.008 43.008 0 1 1-79.872-31.872l150.528-376.064a59.52 59.52 0 0 1 55.232-37.44h5.376a59.52 59.52 0 0 1 55.232 37.44m-57.92 86.4l-53.376 133.632h107.264l-53.888-133.632z m28.032-499.648A172.16 172.16 0 0 1 928 276.992V369.92a43.008 43.008 0 0 1-86.016 0V276.992a85.76 85.76 0 0 0-85.952-86.016h-98.624a43.008 43.008 0 1 1 0-85.952h98.624zM68.096 174.912c0-18.944 15.36-34.24 34.24-34.24H270.08l-8.576-36.928a25.6 25.6 0 0 1 23.68-31.36l30.336-1.472c13.312-0.64 25.28 8.96 28.352 21.888l2.88 12.16c2.56 15.616 4.672 27.52 5.76 35.328h150.208a34.176 34.176 0 1 1 0 68.352h-40.448c-19.712 75.072-53.888 137.792-102.016 189.056q53.184 33.92 128.384 54.656c24.896 6.848 36.928 35.072 22.72 56.64l-0.384 0.64-0.192 0.192c-10.112 12.864-26.56 19.904-42.176 14.912-65.472-20.928-121.28-46.72-167.36-77.824-37.44 26.688-92.096 53.952-164.8 81.92a35.968 35.968 0 0 1-42.624-15.168c-12.8-20.096-3.968-49.088 19.072-57.152 52.416-18.24 96.192-38.464 131.328-60.864-46.592-49.728-80.768-111.936-101.504-186.496l-40.448-0.064a34.176 34.176 0 0 1-34.176-34.176m233.6 173.44A283.584 283.584 0 0 0 382.08 208.96h-160.64c15.616 54.912 41.984 101.568 80.384 139.392v-0.128z"
              p-id="7416"
            ></path>
          </svg>
        </div> -->
        <div class="text" v-if="!$store.getters.token">
          <span class="login" @click="goLogin">登录</span>
          <span style="margin: 0 5px">|</span>
          <span class="register" @click="goLogin">注册</span>
        </div>
        <div style="display: flex; align-items: center;" v-if="$store.getters.token">
          <el-popover placement="top" width="160">
            <el-button type="primary" style="width: 100%;" @click="logout">退出登录</el-button>
            <div slot="reference"
              style="width: 50px;height: 50px; border-radius: 50%; background-color: #2350ec;margin-right: 20px; overflow: hidden;">
              <!-- <img :src="$store.getters.avatarurl" alt="" style="width: 100%; height: 100%;"
                v-if="!!$store.getters.avatarurl"> -->
              <img src="../../../assets/images/avatar.png" alt="" style="width: 100%; height: 100%;">
            </div>
          </el-popover>
          <span>{{ $store.getters.username }}</span>
        </div>
      </div>
      <div class="btn">
        <button @click="ContactUs">联系我们</button>
      </div>
    </div>
    <el-drawer title="联系" :visible.sync="$store.getters.drawer" :direction="direction" :before-close="handleClose">
      <el-form label-width="100px" :model="contactForm" :rules="contactRules" ref="contactRef">
        <el-form-item label="单位名称: " prop="companyName">
          <el-input placeholder="请输入单位名称" v-model="contactForm.companyName" />
        </el-form-item>
        <el-form-item label="联系人名称: " prop="userName">
          <el-input placeholder="请输入联系人名称" v-model="contactForm.userName" />
        </el-form-item>
        <el-form-item label="手机号码: " prop="phone">
          <el-input placeholder="请输入手机号码" v-model="contactForm.phone" />
        </el-form-item>
        <el-form-item label="电子邮箱: " prop="email">
          <el-input placeholder="请输入电子邮箱" v-model="contactForm.email" />
        </el-form-item>
        <el-form-item label="咨询意向: " prop="remark">
          <el-input placeholder="请输入咨询意向" type="textarea" v-model="contactForm.remark" />
        </el-form-item>
        <el-form-item>
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="handleConfirm">提交</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getMenuShowApi, createApi } from '../../../api/common'
import Cookies from 'js-cookie';
import { removeToken } from '@/utils/auth';
export default {
  data() {
    const isValidPhoneNumber = (rule, value, callback) => {
      if (value.length != 11) {
        callback(new Error('手机号码长度不正确!'))
      }
      for (var i = 0; i < value.length; i++) {
        if (value.charAt(i) < '0' || value.charAt(i) > '9') {
          callback(new Error('手机号码含有非法字符!'))
        }
      }
      if (value.charAt(0) != '1') {
        console.log(value.charAt(0), 'value.charAt(0)');

        callback(new Error('手机号码第一位应为1!'))
      }
      if (value.charAt(1) < '3' || value.charAt(1) > '9') {
        callback(new Error('手机号码第二位为无效数字!'))
      }
      callback()
    }
    return {
      current: 0,
      direction: 'rtl',
      nav: [],
      contactForm: {
        userName: '',
        companyName: '',
        phone: '',
        email: '',
        remark: ''
      },
      contactRules: {
        userName: [
          { required: true, trigger: 'blur', message: '请输入联系人名称' }
        ],
        companyName: [
          { required: true, trigger: 'blur', message: '请输入单位名称' }
        ],
        phone: [{ required: true, trigger: 'blur', validator: isValidPhoneNumber }],
        remark: [{ required: true, trigger: 'blur', message: '请输入咨询意向' }],
      }
    }
  },
  created() {
    this.getMenuShowFn()
    console.log(this.$route, 'route');

  },
  computed: {
    ...mapGetters(['mainIndex'])
  },
  methods: {
    toggleNav(index, path) {
      if (this.$route.path != path) {
        this.$router.push(path)
      }

      // if (this.mainIndex != index) {
      //   this.$store.commit('user/SET_MAININDEX', index)
      //   this.current = index
      //   this.$router.push(path)
      // }
    },
    goLogin() {
      this.$router.push('/login')
    },
    async getMenuShowFn() {
      const res = await getMenuShowApi({ companyCode: 'gzkm', menuCode: 'main' })
      if (res.code == 0) {
        this.nav = res.data.childMenu
      }
    },
    ContactUs() {
      this.$store.commit('user/SET_DRAWER', true)
    },
    handleClose() {
      this.$refs.contactRef.resetFields()
      this.$store.commit('user/SET_DRAWER', false)
    },
    handleConfirm() {
      this.$refs.contactRef.validate(async valid => {
        if (!valid) return
        const data = {
          username: this.contactForm.userName,
          companyName: this.contactForm.companyName,
          phone: this.contactForm.phone,
          email: this.contactForm.email,
          remark: this.contactForm.remark
        }
        const res = await createApi(data)
        if (res.code == 0) {
          this.$message({
            type: 'success',
            message: '提交成功!'
          })
          this.handleClose()
        }
      })
    },
    logout() {
      this.$store.commit('user/RESET_STATE')
      Cookies.remove('username')
      Cookies.remove('avatarurl')
      removeToken()
      this.$router.replace('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-container {
  width: 100%;
  min-width: 1600px;
  height: 72px;
  background-color: #fff;
  display: flex;
  align-items: center;
  margin: 0 auto;

  .logo {
    padding-left: 200px;

    img {
      width: 200px;
    }
  }

  .nav-wrap {
    display: flex;
    flex: 1;
    margin: 0 auto;
    justify-content: center;

    .nav-item {
      padding: 0 20px;
      color: #222;
      cursor: pointer;
      font-size: 18px;
    }

    .active {
      color: #2350ec;
      font-weight: bolder;
    }
  }

  .right {
    display: flex;
    align-items: center;
    margin-right: 50px;

    .wrap {
      height: 40px;
      width: 220px;
      background-color: #fff;
      display: flex;
      align-items: center;
      margin-right: 30px;
      justify-content: space-around;

      .search {
        .search-icon {
          svg {
            cursor: pointer;
          }
        }
      }

      .text {
        margin: 0 20px;
        font-size: 17px;
        cursor: pointer;
      }
    }

    .btn {
      width: 120px;
      height: 50px;
      background-color: #2350ec;
      text-align: center;
      line-height: 40px;
      border-radius: 5px;

      button {
        cursor: pointer;
        width: 100%;
        height: 100%;
        background-color: transparent;
        border: none;
        outline: none;
        color: #fff;
        font-size: 17px;
      }
    }
  }
}
</style>
